import axios from './axiosConfig'

export const getCategories = async () => {
  const response = await axios.get('/category')
  return response.data
}

export const addCategory = async (categoryName) => {
  console.log('API call to add category:', categoryName)
  const response = await axios.post(`/category/c/${categoryName}`)
  return response.data
}
